module.exports = __webpack_public_path__ + "img/hone-solution3.ad0725ef.png";